import { Button } from '@ophelos/ui/components/button';
import { CalendarClock, Layers } from 'lucide-react';
import { useTranslation } from '@/hooks/useTranslation';
import { Alert, AlertDescription, AlertTitle } from '@ophelos/ui/components/alert';

export interface AccountPaymentBlockProps {
  /** The blocking plan: `scheduled` / `plan` block a case surface, `case` the account one. */
  variant: 'scheduled' | 'plan' | 'case';
  /** Navigate to where the blocking plan is shown, and can be cancelled. */
  onView: () => void;
}

const VARIANTS = {
  scheduled: { icon: CalendarClock, prefix: 'payment.accountScheduledBlock' },
  plan: { icon: Layers, prefix: 'payment.accountPlanBlock' },
  case: { icon: CalendarClock, prefix: 'payment.casePlanBlock' },
} as const;

/**
 * Shown on a payment surface closed off by a plan at the other scope — the two are
 * mutually exclusive server-side. An account payment also holds cases added after it started.
 */
export function AccountPaymentBlock({ variant, onView }: AccountPaymentBlockProps) {
  const { t } = useTranslation();
  const { icon: Icon, prefix } = VARIANTS[variant];

  return (
    <div className="xs:max-w-lg h-full w-full mx-auto flex flex-col items-center justify-center gap-6 mt-8 px-2 xs:px-4">
      <Alert variant="warning">
        <Icon className="size-4" />
        <AlertTitle>{t(`${prefix}.title`)}</AlertTitle>
        <AlertDescription>
          {t(`${prefix}.description`)}
          <Button variant="outline" onClick={onView} className="w-full mt-2">
            {t(`${prefix}.action`)}
          </Button>
        </AlertDescription>
      </Alert>
    </div>
  );
}
